import type katexModule from 'katex';

export type Katex = typeof katexModule;

let loading: Promise<Katex> | null = null;

/**
 * KaTeX, chargé à la première formule rencontrée.
 *
 * Il pèse près de 300 Ko : l'imposer à l'ouverture de l'application, pour des
 * écrans dont la plupart n'affichent aucune formule, alourdirait chaque
 * connexion. L'extension de chimie (`\ce{H2SO4}`) l'accompagne : elle
 * s'enregistre auprès de KaTeX en s'important.
 */
export function loadKatex(): Promise<Katex> {
  loading ??= import('katex')
    .then(async module => {
      const katex = (module as unknown as { default?: Katex }).default ?? (module as unknown as Katex);
      await import('katex/contrib/mhchem');
      return katex;
    })
    .catch(error => {
      // Un échec (réseau coupé au chargement du fragment) ne doit pas rester
      // en cache : la prochaine formule retentera.
      loading = null;
      throw error;
    });

  return loading;
}
